import { useState, useEffect } from 'react';

export interface Breakpoints {
  xs: boolean; // < 576px
  sm: boolean; // >= 576px
  md: boolean; // >= 768px
  lg: boolean; // >= 992px
  xl: boolean; // >= 1200px
  xxl: boolean; // >= 1600px
}

export const useResponsive = (): Breakpoints => {
  const [breakpoints, setBreakpoints] = useState<Breakpoints>({
    xs: window.innerWidth < 576,
    sm: window.innerWidth >= 576 && window.innerWidth < 768,
    md: window.innerWidth >= 768 && window.innerWidth < 992,
    lg: window.innerWidth >= 992 && window.innerWidth < 1200,
    xl: window.innerWidth >= 1200 && window.innerWidth < 1600,
    xxl: window.innerWidth >= 1600,
  });

  useEffect(() => {
    const handleResize = () => {
      setBreakpoints({
        xs: window.innerWidth < 576,
        sm: window.innerWidth >= 576 && window.innerWidth < 768,
        md: window.innerWidth >= 768 && window.innerWidth < 992,
        lg: window.innerWidth >= 992 && window.innerWidth < 1200,
        xl: window.innerWidth >= 1200 && window.innerWidth < 1600,
        xxl: window.innerWidth >= 1600,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return breakpoints;
};

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};

export const useIsTablet = (): boolean => {
  const [isTablet, setIsTablet] = useState(
    window.innerWidth >= 768 && window.innerWidth < 992
  );

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth >= 768 && window.innerWidth < 992);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isTablet;
};

